
import { useState } from "react";
import { Alert } from "react-bootstrap";
import { IoWarningOutline } from "react-icons/io5";

export function PreprodAlert() {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  return (
    <Alert variant="danger" onClose={() => setShow(false)} dismissible>
      <Alert.Heading className="d-flex align-items-center gap-2">
        <IoWarningOutline /> Attenzione: PRE-PROD
      </Alert.Heading>
      <p>
        Questo ambiente ha le stesse configurazioni di <strong>PRODUZIONE</strong> e contiene dati reali.
      </p>
      <p >
        <strong>Fai attenzione:</strong> qualsiasi operazione effettuata qui potrebbe
        avere conseguenze.
        <span className="d-block">Verifica sempre di essere nell'ambiente corretto prima di procedere con modifiche importanti.</span>
      </p>
    </Alert>
  );
}
